module.exports = function (string, preserve) {
  if (!preserve) {
    string = string.toLowerCase();
  }

  return string.charAt(0).toUpperCase() + string.substring(1);
};

module.exports.words = function (string, preserve) {
  if (!preserve) {
    string = string.toLowerCase();
  }

  return string.replace(/(?!^[0-9])(^|[^a-zA-Z\u00C0-\u017F\u0400-\u04FF'])([a-zA-Z\u00C0-\u017F\u0400-\u04FF])/g, function (m) {
    return m.toUpperCase();
  });
};